import React from "react";
import {observer} from "mobx-react";
import {isMobileOnly} from "react-device-detect";

import "./chart-tools.scss";

import {Button, Icon, Label, Popup} from "semantic-ui-react";
import {TimeSeries, Kiwis} from "../../../../../../../kiwis";
import {DataValueType} from "../../../../../../../kiwis/data-value-type";

interface ChartToolsProps {
    kiwis: Kiwis;
    timeSeries: TimeSeries;
    dataPointsVisible: boolean;
    toggleDataPointVisibility: any;
    chartContentLabel: string | undefined;
    currentMeasurementLabel: string | undefined;
    dateRangeLabel: string | undefined;
    compact: boolean;
}

@observer
export class ChartTools extends React.Component<ChartToolsProps, any> {
    constructor(props: ChartToolsProps) {
        super(props);
    }

    render() {
        const hasRelativeValues = this.props.kiwis.hasRelativeValues(this.props.timeSeries.parameterTypeName) &&
            this.props.timeSeries.dataRelativeValueIndex != null;
        return (
            <div className={`graph-tools ${this.props.compact ? "compact" : ""}`}>
                <div className="chart-content-label">{this.props.chartContentLabel}</div>
                <div className="current-measurement-label">{this.props.currentMeasurementLabel}</div>
                {!isMobileOnly &&
                    <div className="graph-tools-buttons">
                        <div className="graph-tools-buttons-data">
                            <Popup
                                basic className="popup-hints"
                                trigger={
                                    <Button
                                        toggle icon labelPosition="left" size="mini"
                                        className="data-points-toggle"
                                        active={this.props.dataPointsVisible}
                                        onClick={this.props.toggleDataPointVisibility}
                                    >
                                        <Icon name="circle outline"/>
                                        {this.props.dataPointsVisible ? "ausblenden" : "einblenden"}
                                    </Button>
                                }>
                                {this.props.dataPointsVisible ? "Datenpunkte ausblenden" : "Datenpunkte einblenden"}
                            </Popup>
                            <Popup
                                content="Daten aktualisieren" basic
                                className="popup-hints"
                                trigger={
                                    <Button
                                        icon="refresh" size="mini"
                                        className="graph-refresh"
                                        onClick={() => {
                                            this.props.kiwis.loadTimeSeriesData(this.props.timeSeries.id, true);
                                        }}
                                    />}
                            />
                            {hasRelativeValues &&
                                <Popup
                                    content="Relative Werte anzeigen" basic
                                    className="popup-hints"
                                    trigger={
                                        <Button
                                            toggle
                                            icon="registered outline" size="mini"
                                            className="graph-absolute-values"
                                            active={this.props.kiwis.dataValuesType === DataValueType.Relative}
                                            onClick={() => {
                                                this.props.kiwis.toggleDataValueType();
                                            }}
                                        />}
                                />
                            }
                        </div>
                        <Label size="small" className="geo-chart-period-label">
                            <Icon name="calendar alternate outline"/>
                            {this.props.dateRangeLabel}
                        </Label>
                    </div>
                }
            </div>
        );
    }
}
